export default {
  SOURCE_DASHBOARD: 1,
  SOURCE_CONTACT: 2,
  SOURCE_CONTACT_GROUP: 3,
  SOURCE_ROBOT: 4,
};
